export default function capitalizeFilter(value) {
	if (!value) {
		return '';
	}
	value = value.toString();
	return value.charAt(0).toUpperCase() + value.slice(1);
}



// WEBPACK FOOTER //
// ./src/filters/capitalize.js